<header class="settings-page-header" [class.settings-page-header-with-subtitle]="subtitle()">
  @if (backLabel()) {
    <button type="button" class="settings-page-header-back" [attr.aria-label]="backLabel()" (click)="goBack.emit()">
      <app-icon name="sapphire-arrow-left" [size]="20" />
    </button>
  }
  <div class="settings-page-header-copy">
    <h2 [id]="titleId()">{{ heading() }}</h2>
    @if (subtitle()) {
      <p>{{ subtitle() }}</p>
    }
  </div>

  <div class="settings-page-header-actions">
    @if (actionLabel()) {
      <button
        type="button"
        class="settings-page-header-action"
        [disabled]="actionDisabled()"
        (click)="actionPressed.emit()"
      >
        {{ actionLabel() }}
      </button>
    }
    <button type="button" aria-label="Close settings" (click)="closeWindow.emit()">
      <app-icon name="sapphire-close" [size]="20" />
    </button>
  </div>
</header>
